/* istanbul ignore file */
import React from 'react';
import { InputListProps } from 'framework/form';
import CandidateInputList from './CandidateInputList';

const CandidateOfferListInput = ({ inputTemplate, ...props }: InputListProps) => {
  return <CandidateInputList {...props} inputTemplate={inputTemplate} defaultValue={{}} />;
};

export default CandidateOfferListInput;
